<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box">
          <!--<div class="box-header">-->
            <!--<h3 class="box-title">品牌排程列表</h3>-->
          <!--</div>-->
          <!-- /.box-header -->
          <div class="box-body">
            <ul class="nav nav-tabs" style="margin-bottom: 10px;" v-if="!isChart">
              <li role="presentation" :class="{'active': scheduleMethod == 1}" @click="scheduleMethod = 1">
                <a>行銷列表
                </a>
              </li>
              <li role="presentation" :class="{'active': scheduleMethod == 2}" @click="scheduleMethod = 2">
                <a>活動列表
                </a>
              </li>
            </ul>
            <div class="row form-inline m-b-10">
              <div class="col-sm-12 text-left">
                <div class="from-group inline-block pull-left" v-if="scheduleMethod === 1 && !isChart">
                  <router-link :to="{path: '/crMarketing'}">
                    <div class="btn btn-default btn-table-title h-38">新增行銷</div>
                  </router-link>
                </div>
                <div :class="{'m-l-5': scheduleMethod === 1}" class="inline-block from-group pull-left " v-if="brandBrief.length > 1 && $route.name !== 'storeInfo'" style="width: auto; min-width: 150px;">
                  <multiselect
                    v-model="brandSelect"
                    :options="brandBrief"
                    label="label"
                    :searchable="true"
                    :allow-empty="false"
                    :close-on-select="true"
                    placeholder="品牌"
                    :show-labels="false"
                    :preselect-first="true"
                    @input="changeBrand"
                  >
                  </multiselect>
                </div>
                <div class="inline-block from-group pull-left m-l-5" v-if="brandSelect !== 0 && brandSelect !== '0' && storeBrief.length > 1" style="width: auto; min-width: 150px;">
                  <multiselect
                    v-model="storeSelect"
                    :options="storeBrief"
                    label="label"
                    :searchable="true"
                    :allow-empty="false"
                    :close-on-select="true"
                    placeholder="門市"
                    :show-labels="false"
                    :preselect-first="true"
                    @input="changeSelect"
                  >
                  </multiselect>
                </div>
                </div>
              </div>
            <div class="row form-inline">
              <div class="col-sm-12 text-left">
                <div class="inline-block from-group pull-left" style="width: auto; min-width: 150px;">
                  <multiselect
                    v-model="statusSelect"
                    :options="statusList"
                    label="label"
                    :searchable="true"
                    :allow-empty="false"
                    :close-on-select="true"
                    placeholder="行銷狀態"
                    :show-labels="false"
                    :preselect-first="true"
                    @input="changeSelect"
                  >
                  </multiselect>
                </div>
                <div class="inline-block from-group pull-left m-l-5" v-if="roleType === 99 || roleType === 30" style="width: auto; min-width: 150px;">
                  <multiselect
                    v-model="timeMethodSelect"
                    :options="timeMethodList"
                    label="label"
                    :searchable="false"
                    :allow-empty="false"
                    :close-on-select="true"
                    placeholder="行銷時間狀態"
                    :show-labels="false"
                    :preselect-first="true"
                    @input="changeSelect"
                  >
                  </multiselect>
                </div>
                <div class="inline-block from-group m-l-5" v-if="(roleType === 99 || roleType === 30) && !isChart" style="width: auto; min-width: 150px;">
                  <multiselect
                    v-model="ownerTypeSelect"
                    :options="ownerTypeList"
                    label="label"
                    :searchable="false"
                    :allow-empty="false"
                    :close-on-select="true"
                    placeholder="舉辦者"
                    :show-labels="false"
                    :preselect-first="true"
                    class="pull-left"
                    style="min-width: 160px; width: auto;"
                    @input="changeSelect"
                  >
                  </multiselect>
                </div>
              </div>
            </div>
            <div class="col-sm-12 table-responsive p-x-0" v-if="scheduleMethod === 1">
              <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                <thead>
                <tr role="row">
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">行銷名稱(ID)</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">狀態</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="!isChart">備註</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">檔期</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=" "v-if="!isChart">舉辦者</th>
                  <th v-if="!isChart"></th>
                  <th v-if="!isChart"></th>
                  <th v-if="!isChart"></th>
                </tr>
                </thead>
                <tbody v-if="isLoading">
                  <tr>
                    <td colspan="12" class="text-center">資料讀取中......</td>
                  </tr>
                </tbody>
                <tbody v-else-if="marketingList.length === 0">
                  <tr style="background-color: white">
                    <td rowspan="1" colspan="12" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                      <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                      <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else-if="marketingList.length > 0">
                <tr class="even" role="row" v-for="(marketing, index) in marketingList">
                  <!-- cloumn 0 -->
                  <td class="sorting_1">{{index + 1}}</td>
                  <!-- column 1-->
                  <td>
                    <router-link :to="{path: '/marketingInfo/1/detail'}" v-if="!isChart">
                      {{marketing.name}} ({{marketing.promotion_id}})
                    </router-link>
                    <router-link :to="{path: '/couponChart/' + marketing.promotion_id}" v-else>
                      {{marketing.name}} ({{marketing.promotion_id}})
                    </router-link>
                  </td>
                  <td>
                    <label class="label label-default" v-if="marketing.status === 0">未發佈</label>
                    <label class="label label-success" v-else-if="marketing.status === 4">已發佈</label>
                    <label class="label label-danger" v-else="">已下架</label>
                  </td>
                  <!-- column 2-->
                  <td v-if="!isChart">
                    {{marketing.remark}}
                  </td>
                  <!-- column 3-->
                  <td>
                    <label class="label label-default" v-if="marketing.time_method === 'notyet'">未開始</label>
                    <label class="label label-success" v-else-if="marketing.time_method === 'going'">進行中</label>
                    <label class="label label-danger" v-else="">已結束</label>
                    &nbsp;{{getTime(marketing.start_time)}} ~ {{getTime(marketing.end_time)}}
                  </td>
                  <!-- column 4-->
                  <td v-if="!isChart">{{ownerTypeName(marketing.owner_type)}}</td>
                  <td v-if="!isChart">
                    <router-link :to="{path: '/activityList/' + marketing.promotion_id}">
                      <button class="btn btn-primary"><i class="fa fa-volume-down" aria-hidden="true"></i> 活動</button>
                    </router-link>
                  </td>
                  <td v-if="!isChart">
                    <router-link :to="{path: '/upMarketing/' + marketing.promotion_id}">
                      <button class="btn btn-default"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                    </router-link>
                  </td>
                  <td v-if="!isChart">
                    <button class="btn btn-danger" v-if="marketing.status !== 4"
                            data-target="#delModal" data-toggle="modal" @click="setMarketing(marketing.promotion_id)">
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="col-sm-12 table-responsive p-x-0" v-if="scheduleMethod === 2">
              <table aria-describedby="example1_info" role="grid" id="example2" class="table table-bordered table-striped dataTable">
                <thead>
                <tr role="row">
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">活動名稱(ID)</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">狀態</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">商品類型</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">備註</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">檔期</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">行銷分類 (ID)</th>
                  <th></th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr class="even" role="row" v-for="(activity, index) in activityList">
                  <!-- cloumn 0 -->
                  <td class="sorting_1">{{index + 1}}</td>
                  <!-- column 1-->
                  <td>
                    <router-link :to="{path: '/activityInfo/' + activity.activity_id}">
                      {{activity.name}} ({{activity.activity_id}})
                    </router-link>
                  </td>
                  <!-- column 2-->
                  <td>
                    <label class="label label-default" v-if="activity.status === 0">初始化</label>
                    <label class="label label-default" v-else-if="activity.status === 1">編輯中</label>
                    <label class="label label-default" v-else-if="activity.status === 3">待上架</label>
                    <label class="label label-success" v-else-if="activity.status === 4">已上架</label>
                    <label class="label label-danger" v-else="">已下架</label>
                  </td>
                  <td>
                    <label class="label label-primary" v-if="activity.give_type === 1">優惠券</label>
                    <label class="label label-success" v-else-if="activity.give_type === 2">點數</label>
                    <label class="label label-warning" v-else-if="activity.give_type === 3">虛擬序號</label>
                  </td>
                  <td>
                    {{activity.remark}}
                  </td>
                  <!-- column 3-->
                  <td>
                    <label class="label label-default" v-if="activity.time_method === 'notyet'">未開始</label>
                    <label class="label label-success" v-else-if="activity.time_method === 'going'">進行中</label>
                    <label class="label label-danger" v-else="">已結束</label>
                    {{getTime(activity.start_time)}} ~ {{getTime(activity.end_time)}}
                  </td>
                  <!-- column 4-->
                  <td>{{activity.promotion_name}} ({{activity.promotion_id}})</td>
                  <td>
                    <router-link :to="{path: '/upActivity/1'}">
                      <button class="btn btn-primary"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                    </router-link>
                  </td>
                  <td>
                    <button class="btn btn-danger" data-target="#delModal" data-toggle="modal"><i class="fa fa-trash" aria-hidden="true"></i></button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div v-if="marketingList.length !== 0" class="col-xs-12 text-center">
              <ul class="pagination">
                <li class="paginate_button" @click="clickEnd('pre')">
                  <a class="c-pointer"><i class="fa fa-step-backward" aria-hidden="true"></i></a>
                </li>
                <li class="paginate_button"  @click="clickGroup('left')">
                  <a class="c-pointer"><i class="fa fa-backward" aria-hidden="true"></i></a>
                </li>
                <li class="paginate_button" v-for="index in pageAmount" :class="{active: isActive(index)}" @click="clickPage(index)" v-if="pageShow(index)">
                  <a class="c-pointer">{{index}}</a>
                </li>
                <li class="paginate_button disabled" v-for="dis in (groupAmount - Math.ceil(pageAmount % 10))" v-if="pageGroup === Math.ceil(pageAmount / groupAmount)">
                  <a class="c-pointer">&nbsp;&nbsp;</a>
                </li>
                <li class="paginate_button" @click="clickGroup('right')">
                  <a class="c-pointer"><i class="fa fa-forward" aria-hidden="true"></i></a>
                </li>
                <li class="paginate_button" @click="clickEnd('forward')">
                  <a class="c-pointer"><i class="fa fa-step-forward" aria-hidden="true"></i></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-view ></router-view>
    <m-modal :option="delMOption" @trigger="trigger"></m-modal>
    <m-modal :option="delAOption" @trigger="trigger"></m-modal>
    <m-modal :option="removeGNowOption" @trigger="trigger"></m-modal>
    <m-modal :option="saleGNowOption" @trigger="trigger"></m-modal>
    <m-modal :option="removeNowOption" @trigger="trigger"></m-modal>
    <m-modal :option="saleNowOption" @trigger="trigger"></m-modal>
  </section>
</template>

<script>
// Require needed datatables modules
import Multiselect from 'vue-multiselect'
import matcherModal from '../../elements/Modal.vue'
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
/*
import '../../../../static/vendor/ganttView/0.8.8/lib/date.js'
import 'jquery-ui'
import '../../../../static/vendor/ganttView/0.8.8/jquery.ganttView.js'
import '../../../../static/vendor/ganttView/0.8.8/jquery.ganttView.css'
*/

export default {
  components: {
    Multiselect,
    'm-modal': matcherModal
  },
  data () {
    return {
      isChart: false,
      searchStoreId: '',
      scheduleMethod: 1, // 1 = 菜單 ， 2 = 各店
      menuState: 4,
      name: '迷客夏',
      total: 1,
      count: 10,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      menuList: [
        {store_id: 1, store_name: '長春店', menu_name: '夏日菜單', menu_id: '1', status: 3, start_time: '2018/01/01', end_time: '2018/12/31'},
        {store_id: 1, store_name: '中山店', menu_name: '夏日菜單', menu_id: '1', status: 3, start_time: '2018/01/01', end_time: '2018/12/31'},
        {store_id: 1, store_name: '雙連店', menu_name: '菜單B', menu_id: '3', status: 3, start_time: '2018/01/01', end_time: '2018/12/31'},
        {store_id: 1, store_name: '光復店', menu_name: '菜單A', menu_id: '2', status: 3, start_time: '2018/01/01', end_time: '2018/12/31'},
        {store_id: 1, store_name: '民權西路店', menu_name: '菜單B', menu_id: '3', status: 3, start_time: '2018/01/01', end_time: '2018/12/31'},
        {store_id: 1, store_name: '晶華店', menu_name: '菜單C', menu_id: '4', status: 3, start_time: '2018/01/01', end_time: '2018/12/31'}
      ],
      info: {
        menuName: '夏日菜單',
        menu_id: 123323,
        start_time: '2017-03-31 12:22:32',
        end_time: '2017-03-31 12:22:32',
        update_time: '2017-03-31 12:22:32',
        create_time: '2017-03-31 12:22:32'
      },
      menu_schedule_list: [],
      scheduleList: [],
      curGroup: '',
      curSchedule: '',
      delMOption: {
        id: 'delModal',
        title: '刪除行銷',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delMarketing'
          }
        ]
      },
      delAOption: {
        id: 'delModal',
        title: '刪除活動',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delActivity'
          }
        ]
      },
      removeGNowOption: {
        id: 'removeGNowModal',
        title: '檔期群組下架',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'removeGNow'
          }
        ]
      },
      saleGNowOption: {
        id: 'saleGNowModal',
        title: '檔期群組上架',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'saleGNow'
          }
        ]
      },
      removeNowOption: {
        id: 'removeNowModal',
        title: '店家檔期下架',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'removeGNow'
          }
        ]
      },
      saleNowOption: {
        id: 'delModal',
        title: '店家檔期上架',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'saleGNow'
          }
        ]
      },
      // new
      brandBrief: [],
      storeBrief: [],
      brandSelect: {label: '== 所有品牌 ==', value: 0},
      storeSelect: {label: '== 所有門市 ==', value: 0},
      ownerTypeSelect: {label: '== 舉辦者類型 ==', value: 99},
      ownerTypeList: [],
      statusSelect: {label: '== 行銷狀態 ==', value: 99},
      timeMethodSelect: {label: '== 行銷時間狀態 ==', value: 99},
      timeMethodList: [
        {label: '== 行銷時間狀態 ==', value: 99},
        {label: '未開始', value: 'notyet'},
        {label: '進行中', value: 'going'},
        {label: '已結束', value: 'end'}
      ],
      marketingList: [],
      curStoreId: '',
      ownerId: '',
      activityList: [],
      curMarketingId: '',
      curActivityId: '',
      isLoading: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      // console.log(('#select-brand option').text().length)
    })
  },
  methods: {
    ...mapActions(['setBrandId', 'setStoreId']),
    setMarketing (marketingId) {
      this.curMarketingId = marketingId
    },
    setActivity (activityId) {
      this.curActivityId = activityId
    },
    search () {
      if (this.ownerId || this.ownerTypeSelect.value === 99 || this.ownerTypeSelect.value === 1) this.getMarketing(1)
    },
    ownerTypeName (type) {
      switch (type) {
        case 1: return '平台'
        case 2: return '品牌'
        case 3: return '門市'
      }
    },
    changeBrand (input) {
      var self = this
      this.storeBrief = []
      this.storeSelect = []
      this.select
      var brandId = input.value
      if (input.value !== 99 && input.value !== 0) {
        self.getStoreBrief(brandId)
      }
      if (typeof input.value !== 'undefined') {
        if (this.scheduleMethod === 1) this.getMarketing(1)
        else this.getActivity(1)
      }
    },
    changeSelect (input) {
      if (typeof input.value !== 'undefined') {
        if (this.scheduleMethod === 1) this.getMarketing(1)
        else this.getActivity(1)
      }
    },
    changeStore (input) {
      if (typeof input.value !== 'undefined') {
        if (this.scheduleMethod === 1) this.getMarketing(1)
        else this.getActivity(1)
      }
    },
    changeOwnerType (input) {
      if (typeof input.value !== 'undefined') {
        if (this.scheduleMethod === 1) this.getMarketing(1)
        else this.getActivity(1)
      }
    },
    clickGroup (type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1
        this.tableIndex = this.groupAmount * this.pageGroup
        this.clickPage(this.tableIndex)
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1
        this.clickPage(this.tableIndex)
      }
    },
    clickEnd (type) {
      if (type === 'pre') {
        this.clickPage(1)
        this.pageGroup = 1
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount)
        else this.clickPage(1)
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount)
      }
    },
    getTime (time) {
      if (time) {
        return moment(time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm')
      }
    },
    trigger (event) {
      if (event === 'delMarketing') {
        this.delMarketing()
      } else if (event === 'delActivity') {
        this.delActivity()
      }
    },
    delMarketing () {
      var self = this
      var url = '/promotion/' + this.curMarketingId
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '刪除行銷成功',
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.getMarketing()
        }
      })
    },
    delActivity () {

    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    clickPage (index) {
      this.tableIndex = index
      if (this.scheduleMethod === 1) this.getMarketing()
      else if (this.scheduleMethod === 2) this.getActivity()
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    },
    getBrandBrief () {
      var self = this
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          if (self.roleType === 99) {
            var defaultBrand = {label: '== 所有品牌 ==', value: 0}
            self.brandBrief.push(defaultBrand)
            self.brandSelect = defaultBrand
          }
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            self.brandBrief.push(obj)
            if (self.roleType === 30 && i === 0) {
              self.brandSelect = obj
              self.setBrandId(obj.value)
            } else if (self.roleType === 10 && i === 0) {
              self.brandSelect = obj
              self.getStoreBrief(self.brandSelect.value)
            }
          }
          if ((self.roleType === 30 || self.roleType === 99) && self.scheduleMethod === 1) self.getMarketing(1)
          // self.getActivity()
        }
      })
    },
    getStoreBrief (brandId) {
      this.storeBrief = []
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          if (self.roleType !== 10) self.storeBrief.push({label: '== 所有門市 ==', value: 0})
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            if (i === 0) {
              // if (self.getRoleType === '10' || self.getRoleType === 10) self.storeSelect = obj.value
              // self.getMarketing(1)
              self.curStoreId = sList[i].store_id
              if (self.roleType === 10) self.setStoreId(self.curStoreId)
            }
          }
        }
      })
    },
    getMarketing (page) {
      this.isLoading = true
      var self = this
      if (page) {
        this.tableIndex = page
        if (page === 1) this.pageGroup = 1
      }
      var roleType = self.roleType
      var url = '/promotion/list?'
      var data = {
        page: this.tableIndex,
        size: this.count,
        type: 1
      }
      // owner_type
      if (roleType === 10) {
        this.data.owner_type = 3
      } else if ((roleType === 30 || roleType === 99) && self.ownerTypeSelect.value !== 99) {
        data.owner_type = self.ownerTypeSelect.value
      }
      // brand_id
      if (this.brandSelect.value) {
        if (roleType === 30) data.brand_id = this.brandSelect.value
        else if (roleType === 99 && this.brandSelect.value !== 0) data.brand_id = this.brandSelect.value
      }
      // store_id
      if (this.storeSelect.value) {
        if ((roleType === 99 || roleType === 30) && this.storeSelect.value !== 0) data.store_id = this.storeSelect.value
        else if (roleType === 10) data.store_id = this.storeSelect.value
      }
      // status
      var status = [
        {label: '== 行銷狀態 ==', value: 99},
        {label: '未發佈', value: 0},
        {label: '已發佈', value: 4},
        {label: '已下架', value: 9}
      ]
      if (this.statusSelect.value !== 99 && status.find(function (o) { return o.value === self.statusSelect.value })) data.status = this.statusSelect.value
      // time_method
      if (this.timeMethodSelect.value !== 99 && this.timeMethodSelect.value) data.time_method = this.timeMethodSelect.value
      for (var key in data) {
        url = url + key + '=' + data[key] + '&'
      }
      url = url.slice(0, -1)
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.marketingList = response.data.list
          self.total = response.data.list_total
          self.isLoading = false
        }
      })
    },
    getActivity (page) {
      var self = this
      if (page) {
        this.tableIndex = page
        if (page === 1) this.pageGroup = 1
      }
      var url = '/activity/list?'
      var roleType = this.roleType
      var data = {
        page: this.tableIndex,
        size: this.count
      }
      // time_method
      if (this.timeMethodSelect.value !== 99 && this.timeMethodSelect.value) data.time_method = this.timeMethodSelect.value
      // status
      var status = [
        {label: '== 活動狀態 ==', value: 99},
        {label: '初始化', value: 0},
        {label: '編輯中', value: 1},
        {label: '待上架', value: 3},
        {label: '已上架', value: 4},
        {label: '已下架', value: 5}
      ]
      if (this.statusSelect.value !== 99 && status.find(function (o) { return o.value === self.statusSelect.value })) data.status = this.statusSelect.value
      // brand_id
      if (roleType === 99 && typeof this.brandSelect.value !== 'undefined' && this.brandSelect.value !== 0) data.brand_id = this.brandSelect.value
      else if (roleType === 30) data.brand_id = this.brandSelect.value
      // store_id
      if (this.storeSelect.value) {
        if ((roleType === 99 || roleType === 30) && this.storeSelect.value !== 0) data.store_id = this.storeSelect.value
        else if (roleType === 10) data.store_id = this.storeSelect.value
      }
      // owner_type
      if (roleType === 10) {
        this.data.owner_type = 3
      } else if ((roleType === 30 || roleType === 99) && self.ownerTypeSelect.value !== 99) {
        data.owner_type = self.ownerTypeSelect.value
      }
      // check data
      for (var key in data) {
        url = url + key + '=' + data[key] + '&'
      }
      url = url.slice(0, -1)
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.activityList = response.data.list
          self.total = response.data.list_total
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    statusList () {
      if (this.scheduleMethod === 2) {
        return [
          {label: '== 活動狀態 ==', value: 99},
          {label: '初始化', value: 0},
          {label: '編輯中', value: 1},
          {label: '待上架', value: 3},
          {label: '已上架', value: 4},
          {label: '已下架', value: 5}
        ]
      } else {
        return [
          {label: '== 行銷狀態 ==', value: 99},
          {label: '未發佈', value: 0},
          {label: '已發佈', value: 4},
          {label: '已下架', value: 9}
        ]
      }
    },
    scheduleListNew () {
      var menuList = {}
      var oldList = this.menu_schedule_list
      for (var key in oldList) {
        // console.log(oldList[key].menu_id)
        menuList[oldList[key].menu_id] = {
          menu_id: oldList[key].menu_id,
          storeList: []
        }
      }
      for (var k in oldList) {
        menuList[oldList[k].menu_id].storeList.push({
          store_id: oldList[k].store_id,
          store_name: oldList[k].store_name,
          start_time: oldList[k].start_time,
          end_time: oldList[k].end_time,
          status: oldList[k].status,
          update_time: oldList[k].update_time,
          create_time: oldList[k].create_time,
          schedule_id: oldList[k].schedule_id,
          menu_id: oldList[key].menu_id
        })
      }
      return menuList
    },
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    },
    searchPlaceholder () {
      var value = this.ownerTypeSelect.value
      switch (value) {
        case 99:
        case 1:
          return '不用填入'
        case 2:
          return '請填入品牌id'
        case 3:
          return '請填入門市id'
      }
    }
  },
  watch: {
    menuState () {
      this.tableIndex = 1
      this.pageGroup = 1
    },
    scheduleMethod () {
      this.tableIndex = 1
      this.pageGroup = 1
      if (this.scheduleMethod === 1) this.statusSelect = {label: '== 行銷狀態 ==', value: 99}
      if (this.scheduleMethod === 2) this.statusSelect = {label: '== 活動狀態 ==', value: 99}
      this.clickPage(1)
      window.sessionStorage.setItem('Nidin_marketing_table', this.scheduleMethod)
    },
    '$route.name' () {
      if (this.$route.name === 'marketingChart') this.isChart = true
      else this.isChart = false
    }
  },
  created () {
    this.roleType = parseInt(this.getRoleType, 10)
    var sMethod = window.sessionStorage.getItem('Nidin_marketing_table')
    if (sMethod) this.scheduleMethod = parseInt(sMethod, 10)
    this.getBrandBrief()
    if (this.$route.name === 'marketingChart') this.isChart = true
    if (this.roleType === 99) {
      this.ownerTypeList = [
        {label: '== 舉辦者類型 ==', value: 99},
        {label: '平台', value: 1},
        {label: '品牌', value: 2},
        {label: '門市', value: 3}
      ]
    } else if (this.roleType === 30) {
      this.ownerTypeList = [
        {label: '== 舉辦者類型 ==', value: 99},
        {label: '品牌', value: 2},
        {label: '門市', value: 3}
      ]
    }
  }
}
</script>
<style lang="sass">
.gantt
 border: 2px solid #ddd
.menu-info
  min-height: 120px
  width: 100%
  text-align: center
  *
    padding: 0
    margin: 0
    line-height: 25px
.m-b-15
  margin-bottom: 15px !important
.btn-edit-all, .btn-del-all
  margin-right: 15px
  z-index: 100
.nav-page-back, .page-number, .nav-page-next, .nav-zoomIn, .nav-zoomOut
  display: none !important
.fn-gantt .leftPanel
  width: 100px !important
.fn-gantt .leftPanel .fn-wide, .fn-gantt .leftPanel .fn-wide .fn-label
  font-size: 14px
.fn-gantt .navigate
  padding: 10px 0 10px 10px !important
@media screen and (max-width: 499px)
  .min-m-t-10
    margin-top: 25px
</style>



// WEBPACK FOOTER //
// MarketingScheduleTable.vue?93540cdc